import React from 'react';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';
import { CTALink } from '@components/CTALink';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { NewFlag } from '@components/NewFlag';
import { homePageData } from '@data-ts/pages/home';
import { SectionWrapper, ContentColumn, LottieContainer, StyledTextPairing, StyledCloudImage } from './ExpertCurations.styles';

const SECTION_ID = 'New_Rachel_Zoe_Expert_Curations';
const { image, imageMobile, eyebrow, title, body, linkText, link } = homePageData.rachelZoeExpertCurations;

export const ExpertCurations: React.FC = () => {
  return (
    <Box as="section" id={SECTION_ID} padding={6}>
      <SectionWrapper
        background={cloudAssetUrl(image)}
        backgroundMobile={cloudAssetUrl(imageMobile)}
        paddingBottom={[8, 0]}
        alignItems={['flex-end', 'center']}
      >
        <Columns centered>
          <ContentColumn width={6}>
            <LottieContainer
              flexDirection="column"
              justifyContent="center"
              alignItems={['center', 'flex-start']}
              paddingTop={[0, 6]}
              paddingRight={[0, 8]}
            >
              <StyledCloudImage src="home/rachel-zoe/squiggle.svg" />
              <NewFlag
                title={eyebrow}
                titleColor="neutra1"
                flagColor="white"
                flagBackgroundColor="neutra6"
                belowSm={{ flagColor: 'neutra6', flagBackgroundColor: 'humana1Light' }}
              />
              <StyledTextPairing
                titleVariant="calloutHed40Bold"
                titleColor="white"
                titleTagName="h3"
                titleMaxWidth="360px"
                title={title}
                body={body}
                bodyVariant="dek20"
                bodyColor="neutra1"
                bodyMaxWidth="320px"
                marginBottom={5}
                textAlign={['center', 'left']}
              />
              <CTALink id="Expert_Curations_Rachel_Zoe" hasChevron={true} href={link} variant="altPurple">
                {linkText}
              </CTALink>
            </LottieContainer>
          </ContentColumn>
          <Columns.Column width={6}></Columns.Column>
        </Columns>
      </SectionWrapper>
    </Box>
  );
};
